import {
  activeGoodsReceiptsSelector,
  isPOLockedSelector,
} from '../../data/pos.js'
import {poIDSelector} from './poDetailSelectors.js'
import GoodsReceipt from './GoodsReceipt.js'
import ButtonPrimary from '../../common/components/Button/ButtonPrimary.js'
import {createNewGoodsReceipt} from '../PurchaseOrderListPage/Modals/GoodsReceiptModal/goodsReceiptModalFunctions.js'
import {useSelector} from '../../store.js'

export default function GoodsReceiptsPanel() {
  const poID = useSelector(poIDSelector)
  const goodsReceipts = useSelector((state) =>
    activeGoodsReceiptsSelector(state, {poID}),
  )
  const isPOLocked = useSelector((state) => isPOLockedSelector(state, {poID}))

  if (goodsReceipts.length === 0) {
    return (
      <div className="align-center margin-top-10 margin-bottom-10">
        <p className="fs-01 lh-md margin-bottom-10">
          <strong>There are no goods receipts for this purchase order.</strong>
        </p>
        <ButtonPrimary
          size="sm"
          isOutlined
          onClick={() => createNewGoodsReceipt(poID)}
          disabled={isPOLocked}
        >
          Add a Goods Receipt
        </ButtonPrimary>
      </div>
    )
  }

  return (
    <>
      {goodsReceipts.map((goodsReceipt) => (
        <GoodsReceipt
          key={goodsReceipt.goods_receipt_id}
          goodsReceipt={goodsReceipt}
        />
      ))}
    </>
  )
}
